import {IConnectionStatus} from '../../../incase-domain/connectionStatus';

export const UPDATE_CONNECTION_STATUS = 'UPDATE_CONNECTION_STATUS';

export interface IUpdateConnectionStatusAction {
    type: typeof UPDATE_CONNECTION_STATUS;
    payload: IConnectionStatus;
}

export type ConnectionStatusReducerType = IUpdateConnectionStatusAction;
